import { render, staticRenderFns } from "./TestingCentersPage.vue?vue&type=template&id=7d9867be&"
import script from "./TestingCentersPage.vue?vue&type=script&lang=ts&"
export * from "./TestingCentersPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports